import { render } from "./Pay.vue?vue&type=template&id=a142a5c0&scoped=true"
import script from "./Pay.vue?vue&type=script&lang=js"
export * from "./Pay.vue?vue&type=script&lang=js"

import "./Pay.vue?vue&type=style&index=0&id=a142a5c0&scoped=true&lang=scss"

import exportComponent from "D:\\web-master\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a142a5c0"]])

export default __exports__